import { Customer, Staff, Store } from '@ca/common/types'
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics'
import { AnalyticsProvider } from './AnalyticsProvider'
import firebaseApp from './initFbApp'

let cachedGa: ReturnType<typeof getAnalytics> | null = null
const getGa = () => {
  if (cachedGa) return cachedGa
  if (typeof window === 'undefined') return null
  cachedGa = getAnalytics(firebaseApp)
  return cachedGa
}

export const GaAnalytics: AnalyticsProvider = {
  trackScreen: (pathname) => {
    // We could log params but GA limits param value to 100 chars and we can have long search params
    const ga = getGa()
    if (!ga) return
    logEvent(ga, 'screen_view', {
      firebase_screen: pathname,
      firebase_screen_class: pathname,
    })
  },
  trackLogin: (method: string) => {
    const ga = getGa()
    if (!ga) return
    logEvent(ga, 'login', {
      method,
    })
  },
  setProperty: (key: string, value: string | null) => {
    const ga = getGa()
    if (!ga) return
    setUserProperties(ga, {
      [key]: value,
    })
  },
  setSession: (sessionId: string | null) => {
    const ga = getGa()
    if (!ga) return
    setUserProperties(ga, { session: sessionId || null })
  },
  setCustomer: (customer: Customer | null) => {
    const ga = getGa()
    if (!ga) return
    setUserProperties(ga, {
      customer: customer?.id ? `${customer.id}` : null,
      customerRef: customer?.ref ?? null,
    })
  },
  setStaff: (staff: Staff | null) => {
    const ga = getGa()
    if (!ga) return
    setUserProperties(ga, { staff: staff ? `${staff.id}` : null })
  },
  setStore: (store: Store | null) => {
    const ga = getGa()
    if (!ga) return
    setUserProperties(ga, {
      store: store ? `${store.id}` : null,
      storeName: store?.name || null,
      storeRef: store?.ref || null,
      region: store?.region || null,
    })
  },
  logEvent: (event, params) => {
    const ga = getGa()
    if (!ga) return
    logEvent(ga, event, params)
  },
}
